module.exports = __webpack_public_path__ + "img/homer-plessy.1cf62c38.png";